<template>
	<el-drawer title="取消认领记录" :visible.sync="drawer" :append-to-body="true" class="apply-sample-drawer" :before-close="handleClose" size="720px">
		<!-- 列表部分 -->
		<div class="table">
			<el-table
				class="table-small"
				header-row-class-name="table-header-row"
				row-class-name="table-row"
				:data="tableData"
				ref="multipleTable"
				row-key="id"
			>
				<el-table-column label="取消认领达人数" prop="total" width="120"></el-table-column>
				<el-table-column label="原跟进商务" prop="user_names" width="120"></el-table-column>
				<el-table-column label="操作时间" prop="operate_time" width="100"></el-table-column>
				<el-table-column label="操作人" prop="operator_name" width="120"></el-table-column>
				<el-table-column prop="livePrice" label="状态">
					<template slot-scope="{ row }">
						<div class="flex-row-align-center" v-if="row.task_status === 0">
							<i class="el-icon-loading"></i>
							<span class="ml-4">正在处理中...</span>
						</div>
						<div class="flex-row-align-center" v-if="row.task_status === 1">
							<i class="circle" style="background-color: #00b42a"></i>
							<span class="ml-4">处理成功</span>
						</div>
						<div class="flex-row-align-center" v-if="row.task_status === 2">
							<i class="circle" style="background-color: #f53f3f"></i>
							<span class="ml-4">处理失败</span>
						</div>
						<div v-if="row.task_status === 3">
							<div class="flex-row-align-center">
								<i class="circle" style="background-color: #b125bc"></i>
								<span class="ml-4">部分成功</span>
							</div>
							<p>
								<span>成功</span>
								<span class="yx-color-success ml-2">{{ row.success_num }}</span>
								<span class="ml-16">失败</span>
								<span class="yx-color-danger ml-2">{{ row.fail_num }}</span>
							</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="livePrice" label="操作">
					<template slot-scope="{ row }">
						<el-button v-if="row.fail_url" type="text" size="mini" @click="handleDownLink(row.fail_url)">下载失败数据</el-button>
						<span v-else>-</span>
					</template>
				</el-table-column>
			</el-table>
			<yx-pagination
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			/>
		</div>

		<!-- 底部按钮部分 -->
		<div class="bott">
			<div>
				<el-button @click="handleClose">我知道了</el-button>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { cancelAnchorBatchCancelRecords } from '@/api/talentCRM';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			drawer: false,
			tableData: [],
			productId: '',
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			total: 0,
			timer: null,
		};
	},
	methods: {
		async show() {
			this.getList();
			this.getInterval();
			this.drawer = true;
		},
		getInterval() {
			this.timer && clearInterval(this.timer);
			this.timer = setInterval(() => this.getList(), 5000);
		},
		handleClose() {
			this.tableData = [];
			this.pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			clearInterval(this.timer);
			this.drawer = false;
		},
		sizeChange(value) {
			this.pageInfo.page_size = value;
			this.getList();
		},
		currentChange(value) {
			this.pageInfo.page_index = value;
			this.getList();
		},
		handleDownLink(url = '') {
			window.open(url, '_blank');
		},
		async getList() {
			const { list = [], page = {} } = await cancelAnchorBatchCancelRecords({ ...this.pageInfo, platform_id: this.platformId });
			if (list.length === 0) {
				clearInterval(this.timer);
			}
			this.tableData = list;
			this.total = page.item_total || 0;
		},
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-drawer__body {
	padding: 24px !important;
	padding-bottom: 64px !important;
}
.circle {
	display: flex;
	width: 6px;
	height: 6px;
	border-radius: 6px;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
</style>
